import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PlayerScoreService } from './../../services/player-score.service';
import { TopbarStateService } from './../../services/topbar-state.service';

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.less'],
  animations: [
    trigger(
      'inTopAnimation',
      [
        transition(
          ':enter',
          [style({ top: "-4em" }),
          animate('0.6s ease-in-out',
            style({ top: "0", height: "9vh" })),
          animate('0.6s ease-in-out',
            style({ top: 0, height: "8vh" }))
          ]
        )
      ]
    )
  ]
})
export class TopBarComponent implements OnInit, OnDestroy {

  private stateSubs: Subscription;
  private subs: Subscription[] = [];
  public stepScore: number = 0;
  private animationInterval;
  constructor(private topbarState: TopbarStateService,
    private playerScore: PlayerScoreService,
    private renderer: Renderer2,
    private router: Router) {



  }

  public goToMain() {
    this.router.navigate(["main-menu"]);
  }
  public get state() {
    return this.topbarState.stateObs;
  }

  public get score() {
    return this.playerScore.scoreObs;
  }

  public get tries() {
    return this.playerScore.triesObs;
  }

  public get resources() {
    return this.playerScore.resObs;
  }

  buyTries() {
    this.playerScore.addTries(100);
  }
  buyResources() {
    this.playerScore.addResources(10000);

  }

  ngOnInit(): void {

  }
  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

}
